const CONSTANTS = {
    API_BASE_PATH: process.env.VUE_APP_API_BASE_PATH
}

export default CONSTANTS
